// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sortby-mobile[data-v-177bd512]:after{--tw-bg-opacity:1;background-color:#e5e9f0;background-color:rgba(229,233,240,var(--tw-bg-opacity));border-radius:.25rem;bottom:0;content:\"\";display:block;left:0;position:absolute;right:0;top:0;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
